import { Trans } from '@lingui/macro';
import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { useWeb3Context } from 'src/libs/hooks/useWeb3Context';

import { HealthFactorNumber } from '../../components/HealthFactorNumber';
import { FormattedNumber } from '../../components/primitives/FormattedNumber';
import { NoData } from '../../components/primitives/NoData';
import { TopInfoPanelItem } from '../../components/TopInfoPanel/TopInfoPanelItem';
import { useAppDataContext } from '../../hooks/app-data-provider/useAppDataProvider';

export const LendingTopPanel = () => {
  const { user, loading } = useAppDataContext();
  const { currentAccount } = useWeb3Context();
  const theme = useTheme();
  const downToSM = useMediaQuery(theme.breakpoints.down('sm'));

  const valueTypographyVariant = downToSM ? 'main16' : 'main21';
  const noDataTypographyVariant = downToSM ? 'secondary16' : 'secondary21';

  return (
    <Box
      sx={{
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 8 },
      }}
    >
      <Container sx={{ pb: 0 }}>
        <Box sx={{ px: 0 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '28px', md: '32px' }
            }}
          >
            Lending
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 8,
              flexWrap: 'wrap',
              width: '100%',
              mt: 4,
            }}
          >
            <TopInfoPanelItem title={<Trans>Net worth</Trans>} loading={loading} hideIcon>
              {currentAccount ? (
                <FormattedNumber
                  value={Number(user?.netWorthUSD || 0)}
                  symbol="USD"
                  variant={valueTypographyVariant}
                  visibleDecimals={2}
                  compact
                  symbolsColor="#62677B"
                  symbolsVariant={noDataTypographyVariant}
                />
              ) : (
                <NoData variant={noDataTypographyVariant} sx={{ opacity: '0.7' }}/>
              )}
            </TopInfoPanelItem>

            <TopInfoPanelItem
              title={
                <div style={{ display: 'flex' }}>
                  <Trans>Net APY</Trans>
                </div>
              }
              loading={loading}
              hideIcon
            >
              {currentAccount && Number(user?.netWorthUSD) > 0 ? (
                <FormattedNumber
                  value={user.netAPY}
                  variant={valueTypographyVariant}
                  visibleDecimals={2}
                  percent
                  symbolsColor="#A5A8B6"
                  symbolsVariant={noDataTypographyVariant}
                />
              ) : (
                <NoData variant={noDataTypographyVariant} sx={{ opacity: '0.7' }}/>
              )}
            </TopInfoPanelItem>

            {currentAccount && user?.healthFactor !== '-1' && (
              <TopInfoPanelItem
                title={
                  <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <Trans>Health factor</Trans>
                  </Box>
                }
                loading={loading}
                hideIcon
              >
                <HealthFactorNumber
                  value={user?.healthFactor || '-1'}
                  variant={valueTypographyVariant}
                />
              </TopInfoPanelItem>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
